// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ou-J","colMin":"styles_colMin__t5ow6"};